import React, { useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Accueil } from '../pages/Accueil';
import { Coffre } from '../pages/Coffre';
import { Deck } from '../pages/Deck';
import { Stats } from '../pages/Stats';
import M from 'materialize-css'

export const Container = () => {

    //Initialisation materialize JS
    useEffect(() => {
        M.AutoInit();
    },[])
    
    return (
        <main className='main-container'>
            <div className="parallax-container">
                <div className="parallax"><img src="img/front-bg-small.jpg" alt='img' /></div>
            </div>
            
            <Routes>
                <Route path="" element={<Accueil />} />
                <Route path="deck" element={<Deck />} />
                <Route path="coffre" element={<Coffre />} />
                <Route path="stats" element={<Stats />} />
            </Routes>

        </main>);
};
